/**
 * Hub inbox status labels and row CSS classes.
 * canonical: S2 lines 1606–1650 (.pm-ibx-i, .pm-ibx-from status text)
 */

import type { HubUploadStatus, HubInboxItem } from '../../../api/types'

export function statusLabel(status: HubUploadStatus): string {
  switch (status) {
    case 'approved':
      return 'Approved'
    case 'rejected':
      return 'Rejected'
    case 'changes_requested':
      return 'Changes requested'
    case 'pending':
    default:
      return 'Pending review'
  }
}

/** Explicit status chip for inbox rows — Paid overrides Approved. */
export function inboxStatusChip(item: Pick<HubInboxItem, 'status' | 'paid_at'>): { label: string; cls: string } {
  if (item.paid_at) return { label: 'Paid', cls: 'c-grn' }
  if (item.status === 'approved') return { label: 'Approved', cls: 'c-grn' }
  if (item.status === 'rejected') return { label: 'Rejected', cls: 'c-red' }
  if (item.status === 'changes_requested') return { label: 'Changes requested', cls: 'c-amb' }
  return { label: 'Pending review', cls: 'c-blue' }
}

/** Sub payments aggregate row chip. */
export function subPaymentStatusChip(row: { paid: number; approved: number; outstanding: number }): { label: string; cls: string } | null {
  if (row.paid > 0 && row.outstanding <= 0.02) return { label: 'Paid', cls: 'c-grn' }
  if (row.approved > 0 && row.outstanding > 0.02) return { label: 'Approved', cls: 'c-grn' }
  if (row.approved > 0) return { label: 'Approved', cls: 'c-grn' }
  return null
}

/** CSS class suffix for pm-ibx-i row (empty string = default pending). */
export function statusRowClass(status: HubUploadStatus): string {
  switch (status) {
    case 'approved':
      return ' approved'
    case 'rejected':
      return ' rejected'
    case 'changes_requested':
      return ' changes-requested'
    default:
      return ''
  }
}

/** Inbox filter: changes_requested counts as pending. */
export function matchesInboxFilter(
  status: HubUploadStatus,
  filter: 'all' | 'pending' | 'approved' | 'rejected',
): boolean {
  if (filter === 'all') return true
  if (filter === 'approved') return status === 'approved'
  if (filter === 'rejected') return status === 'rejected'
  return status === 'pending' || status === 'changes_requested'
}

/** Mark icon content — doc type fallback only (status shown as chip). */
export function statusMarkContent(status: HubUploadStatus, docTypeFallback: string): string {
  if (status === 'approved') return docTypeFallback
  return docTypeFallback
}
